<script>
export default {
  name: 'generic.password',
  data: () => ({
    show: false
  }),
  computed: {
    fieldType () {
      return this.show ? 'text' : 'password'
    }
  }
}
</script>
<template>
  <b-input-group>
    <b-form-input
      :type="fieldType"
      v-bind="$attrs"
      v-on="$listeners"
      v-on:focus="$event.target.select()"
    ></b-form-input>
    <b-input-group-append class="bg-white">
      <b-btn
        variant="white"
        class="border"
        style="border-color:#ced4da !important"
        v-on:click="show = !show"
      >
        <i class="bx" :class="{ 'bx-hide': show, ' bx-show': !show }"></i
      ></b-btn>
    </b-input-group-append>
  </b-input-group>
</template>
